document.addEventListener("DOMContentLoaded", () => {
  const productIdToCheck = "9605375328595"; // Ersetze mit der ID des Moduls
  const freeProductId = "9676768477523"; // Ersetze mit der ID des kostenlosen Produkts
  const minimumQuantity = 36; // Mindestanzahl der Module

  // Funktion, um den Warenkorb zu prüfen
  function checkCartAndAddProduct() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        let productInCart = false;
        let productQuantity = 0;

        // Überprüfen, ob das Modul bereits im Warenkorb ist
        cart.items.forEach((item) => {
          if (item.id == productIdToCheck) {
            productInCart = true;
            productQuantity = item.quantity;
          }
        });

        // Wenn die Mindestanzahl erreicht ist, füge das kostenlose Produkt hinzu
        if (productInCart && productQuantity >= minimumQuantity) {
          let freeProductInCart = false;

          cart.items.forEach((item) => {
            if (item.id == freeProductId) {
              freeProductInCart = true;
            }
          });

          // Wenn das kostenlose Produkt noch nicht im Warenkorb ist, füge es hinzu
          if (!freeProductInCart) {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: freeProductId,
                quantity: 1,
              }),
            }).then(() => {
              console.log("Kostenloses Produkt wurde hinzugefügt");
              location.reload(); // Aktualisiere die Seite
            });
          }
        }
      });
  }

  // Warenkorb bei Änderungen prüfen
  document.body.addEventListener("click", (e) => {
    if (e.target.matches("[name='add']") || e.target.matches("[name='update']")) {
      setTimeout(checkCartAndAddProduct, 1000); // Verzögerung für die Aktualisierung
    }
  });

  // Initialer Check beim Laden der Seite
  checkCartAndAddProduct();
});